<script setup lang="ts">
import { RouterView, useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'
import { dbService } from './services/database'

const router = useRouter()
const currentUser = ref<any>(null)
const menuOpen = ref(false)

const logout = () => {
  sessionStorage.removeItem('currentUser')
  menuOpen.value = false
  router.push('/')
}


const toggleMenu = (e?: Event) => {
  menuOpen.value = !menuOpen.value
  if (e) e.stopPropagation()
}

onMounted(() => {
  const s = sessionStorage.getItem('currentUser')
  if (s) {
    try { currentUser.value = JSON.parse(s) } catch { currentUser.value = null }
  }
  // close menu on outside click
  window.addEventListener('click', () => { menuOpen.value = false })
})
</script>

<template>
  <div id="app-shell">
    <RouterView />
  </div>
</template>

/* All global styles moved to main.css */

<style scoped>
.app-user-menu {
  position: fixed;
  top: 8px;
  right: 12px;
  z-index: 2000;
}

.user-btn {
  background: transparent;
  border: 2px solid rgba(0,0,0,0.1);
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}
</style>
